
















































import { Mutations, Actions } from '@/ts/store/Constants';
import { Component, Vue } from 'vue-property-decorator';
import Croppa from 'vue-croppa';
import { ImageCropperTargets } from '@/ts/store/Constants';

@Component({
    components: {
        croppa: Croppa.component,
    },
})
export default class ImageCropper extends Vue {
    public croppa: any = {};
    public removeVisible: boolean = false;

    // Lifetime hooks
    constructor() {
        super();
    }

    get viewportSize() {
        return this.$store.getters['Viewport/viewportSize'];
    }

    public saveImage(): void {
        switch (this.$store.getters['Images/cropperTarget']) {
            case ImageCropperTargets.ProfileImage:
                this.$store.dispatch(Actions.SAVE_PROFILE_IMAGE, this.croppa.generateDataUrl())
                    .then(() => {
                        this.$store.commit(Mutations.HIDE_IMAGE_CROPPER, true);
                    });

                break;

            default:
                break;
        }
    }

    public dismissDialog(): void {
        this.$store.commit(Mutations.HIDE_IMAGE_CROPPER, true);
    }

    private handleCroppaInit() {

    }

    private handleCroppaFileChoose() {

    }

    private handleCroppaFileSizeExceed() {

    }

    private handleCroppaFileTypeMismatch() {

    }

    private handleNewImage() {
        this.removeVisible = true;
    }

    private handleImageRemove() {
        this.removeVisible = false;
    }

    private handleCroppaMove() {

    }

    private handleCroppaZoom() {

    }
}
